module.exports = __webpack_public_path__ + "static/media/day.e4ce96f6.png";